<div class="content dashboard-wrapper">
    <div class="container-fluid px-0">
        <mat-progress-bar *ngIf="FilterLoader" mode="indeterminate" class="dashboard-progress"></mat-progress-bar>

        <!-- Top Bar -->
        <div class="dashboard-topbar">
            <div class="topbar-left">
                <span class="topbar-title">Dashboard</span>
            </div>
            <div class="topbar-right">
                <div class="user-badge user-badge-hover">
                    <div class="user-avatar">{{ loggedUser?.charAt(0)?.toUpperCase() }}</div>
                    <span class="user-name">{{ loggedUser }}</span>
                    <div class="user-popover">
                        <div class="popover-header">
                            <div class="popover-avatar">{{ loggedUser?.charAt(0)?.toUpperCase() }}</div>
                            <div>
                                <div class="popover-header-name">{{ loggedUser }}</div>
                                <div class="popover-header-role">{{ userTypeCheck }}</div>
                            </div>
                        </div>
                        <div class="popover-body">
                            <div class="popover-row">
                                <span class="popover-label">Department :</span>
                                <span class="popover-value dept-popover-value">{{ loggedUserDepartment }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <button class="sync-btn" mat-raised-button (click)="ZincDB();">
                    <span>Synchronize DB</span>
                </button>
            </div>
        </div>

        <div class="card dashboard-card" *ngIf="isShown">
            <div class="card-body">

                <!-- Loader -->
                <div class="loader-center" *ngIf="loaderShown">
                    <span class="loader"></span>
                </div>

                <!-- Notification -->
                <div class="dash-alert dash-alert-success" *ngIf="Notification">
                    <span class="alert-icon">✓</span>
                    <span>{{ Message }}</span>
                </div>

                <!-- Filters -->
                <section class="filter-bar">

                    <!-- Row 1: Year / Month / User Type / User -->
                    <div class="filter-row">
                        <div class="filter-group">
                            <label class="filter-label">Year</label>
                            <select name="year" id="year" class="form-select dash-select" [(ngModel)]="SelectedYear"
                                (ngModelChange)="checkUsertype()">
                                <option *ngFor="let year of TotalYear">{{ year }}</option>
                            </select>
                        </div>

                        <div class="filter-group">
                            <label class="filter-label">Month</label>
                            <select name="month" id="month" class="form-select dash-select" [(ngModel)]="SelectedMonth"
                                (ngModelChange)="checkUsertype()">
                                <option *ngFor="let month of Month" [value]="month.value">{{ month.month }}</option>
                            </select>
                        </div>

                        <div class="filter-group" *ngIf="IsAdmin">
                            <label class="filter-label">User Type</label>
                            <select name="usertype" id="usertype" class="form-select dash-select"
                                [(ngModel)]="SelectedUsertype" (ngModelChange)="checkUsertype()">
                                <option *ngFor="let usertype of UserType">{{ usertype }}</option>
                            </select>
                        </div>

                        <div class="filter-group" *ngIf="IsAdmin">
                            <label class="filter-label">User</label>
                            <ng-select [items]="UserDropdown" placeholder="Select User" bindLabel="user_fullname"
                                bindValue="user_fullname" name="user_fullname" id="user_fullname"
                                (change)="employeeSelected($event)" (search)="getUserSearch($event)">
                            </ng-select>
                        </div>

                    </div><!-- /filter-row -->

                    <!-- Row 2: Department full width -->
                    <div class="filter-row dept-row">
                        <div class="filter-group dept-filter-group">
                            <label class="filter-label">Department</label>
                            <ng-select #deptSelect [multiple]="true" [closeOnSelect]="false"
                                [items]="DepartmentDropdown" [(ngModel)]="selectedDepartments"
                                placeholder="Select Department" bindLabel="department_name" bindValue="department_id"
                                name="department_name" id="department_name" (change)="onDepartmentChange($event)">
                                <ng-template ng-header-tmp>
                                    <div class="dept-select-all" (click)="toggleSelectAllDepts()">
                                        <input type="checkbox" [checked]="allDeptsSelected"
                                            (click)="$event.stopPropagation()"
                                            style="pointer-events:none; width:15px; height:15px; accent-color:#1a73e8;" />
                                        <span>{{ allDeptsSelected ? 'Unselect All' : 'Select All' }}</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                    </div><!-- /dept-row -->

                </section>

                <!-- Charts Grid -->
                <section class="charts-grid">

                    <div class="chart-card" *ngIf="Viewemployee">
                        <h2 class="chart-title">Monthly Sales Customer Count</h2>
                        <div class="chart-canvas-wrap">
                            <div class="chart-skeleton" *ngIf="FilterLoader">
                                <span class="loader"></span>
                            </div>
                            <canvas *ngIf="!FilterLoader" baseChart [type]="'pie'" [datasets]="EmployeeCustomercountpieChartDatasets"
                                [labels]="EmployeeCustomercountpieChartLabels" [options]="pieChartOptions"
                                [plugins]="pieChartPlugins" [legend]="pieChartLegend">
                            </canvas>
                        </div>
                    </div>

                    <div class="chart-card" *ngIf="Viewemployee">
                        <h2 class="chart-title">Monthly Sales</h2>
                        <div class="chart-canvas-wrap">
                            <div class="chart-skeleton" *ngIf="FilterLoader">
                                <span class="loader"></span>
                            </div>
                            <canvas *ngIf="!FilterLoader" baseChart [type]="'pie'" [datasets]="EmployeeCustomerpieChartDatasets"
                                [labels]="EmployeeCustomerpieChartLabels" [options]="pieChartOptions"
                                [plugins]="pieChartPlugins" [legend]="pieChartLegend">
                            </canvas>
                        </div>
                    </div>

                    <div class="chart-card">
                        <h2 class="chart-title">Qualified Customers <span class="chart-subtitle">(3M Avg)</span></h2>
                        <div class="chart-canvas-wrap">
                            <div class="chart-skeleton" *ngIf="FilterLoader">
                                <span class="loader"></span>
                            </div>
                            <canvas *ngIf="!FilterLoader" baseChart [type]="'pie'" [datasets]="pieChartDatasets" [labels]="pieChartLabels"
                                [options]="pieChartOptions" [plugins]="pieChartPlugins" [legend]="pieChartLegend">
                            </canvas>
                        </div>
                    </div>

                    <div class="chart-card">
                        <h2 class="chart-title">Non Qualified Customers <span class="chart-subtitle">(3M Avg)</span>
                        </h2>
                        <div class="chart-canvas-wrap">
                            <div class="chart-skeleton" *ngIf="FilterLoader">
                                <span class="loader"></span>
                            </div>
                            <canvas *ngIf="!FilterLoader" baseChart [type]="'pie'" [datasets]="nonpieChartDatasets"
                                [labels]="nonpieChartLabels" [options]="pieChartOptions" [plugins]="pieChartPlugins"
                                [legend]="pieChartLegend">
                            </canvas>
                        </div>
                    </div>

                    <div class="chart-card">
                        <h2 class="chart-title">Customer wise Receivables</h2>
                        <div class="chart-canvas-wrap">
                            <div class="chart-skeleton" *ngIf="FilterLoader">
                                <span class="loader"></span>
                            </div>
                            <canvas *ngIf="!FilterLoader" baseChart [type]="'pie'" [datasets]="ReceivablespieChartDatasets"
                                [labels]="ReceivablespieChartLabels" [options]="pieChartOptions"
                                [plugins]="pieChartPlugins" [legend]="pieChartLegend">
                            </canvas>
                        </div>
                    </div>

                </section>

            </div>
        </div>
    </div>
</div>